import React from 'react';
import { Tooltip, Typography } from '@mui/material';

const types = {
    none: '',
    light: 'btn-light-{variant}',
    outline: 'btn-outline-{variant}'
};

const sizes = {
    xsmall: 'xs',
    small: 'sm',
    medium: 'md',
    large: 'lg'
};

const defaultClassName = 'font-weight-bold btn btn-icon btn-circle btn-text-{variant}';

const replaceVariant = /\{variant\}/g;

export function ButtonIcon ({
    icon,
    onClick,
    type = 'hover-light',
    size = 'medium',
    title = 'Aceptar',
    variant = 'primary',
    hidden = false,
    buttonType,
    disabled = false
}) {
    const className = `${defaultClassName} btn-${(sizes[size] || '')} btn-icon-${variant} ${(types[type] || '')}`.replace(replaceVariant, variant);

    return (
        <>
            {
                !disabled ? (
                    <Tooltip hidden={hidden} title={<Typography fontSize={16} color={'white'}>{title}</Typography>}>
                        <span>
                            <button disabled={disabled} type={buttonType} className={className} onClick={onClick}>
                                {icon}
                            </button>
                        </span>
                    </Tooltip>
                ) : (
                    <button disabled={disabled} type={buttonType} className={className} onClick={onClick}>
                        {icon}
                    </button>
                )
            }
        </>
    );
}

// Set display names for debugging.
if (process.env.NODE_ENV !== 'production') {
    ButtonIcon.displayName = 'ButtonIcon';
}
